import React, { useEffect, useState } from 'react';
import './index.css';
import {
  Section,
  SearchIcon,
  Fieldset,
  Field,
  FieldBody,
  FieldLabel,
  Table,
  TableBody,
  TableBodyRow,
  TableBodyCell,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Button,
  EditIcon,
  Toolbar,
  ToolbarItem,
  Select,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronHardStopIcon,
  Typeahead,
  TypeaheadItem,
  TypeaheadItemSuggestion,
  TextInput,
  Search,
  Grid,
  GridItem
} from '@emorg-prd/react-standard';
import LocationService from '../../../../api/LocationService';
import Country from '../../../../api/Country';
import CountrySubdivision from '../../../../api/CountrySubdivision';
import City from '../../../../api/City';
import Site from '../../../../api/Site';
import OperationStatus from '../../../../api/OperationStatus';
import PrimaryUseType from '../../../../api/PrimaryUseType';
import SearchModel from '../../../../api/SearchModel';
import LoaderIcon from '../../../loaderIcon';

function SearchLocation(props) {
  const [pageLoaded, setPageLoaded] = useState(true);
  const [errorCode, setErrorCode] = useState('');
  const [country, setCountry] = useState({ id: 0, name: '' });
  const [countrySubdivision, setCountrySubdivision] = useState({ id: 0, name: '' });
  const [locationName, setLocationName] = useState('');
  const [locationCity, setLocationCity] = useState('');
  const [locationStreetAddress1, setAddress] = useState('');
  const [locationPostalCode, setLocationPostalCode] = useState('');
  const [sourceSystemReferenceId, setSourceSystemReferenceId] = useState('');
  const [siteName, setSiteName] = useState('');
  const [siteId, setSiteId] = useState('');
  const [siteList, setSiteList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countrySubdivisionList, setCountrySubdivisionList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageList, setPageList] = useState([]);
  const [countrySubdivisionDropdown, setCountrySubdivisionDropdown] = useState([]);
  const [locationCityDropdown, setLocationCityDropdown] = useState([]);
  const [pageLength, setPageLength] = useState(10);
  const [locationList, setLocationList] = useState([]);
  const [operationStatusList, setOperationStatusList] = useState([]);
  const [useTypeList, setUseTypeList] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    const newLocation = locationList.filter(
      (locations) =>
        (locations.locationName || '').toLowerCase().trim()
          .includes((locationName || '').toLowerCase().trim()) &&
        (locations.locationStreetAddress1 || '').toLowerCase().trim()
          .includes((locationStreetAddress1 || '').toLowerCase().trim()) &&
        (locations.locationCity || '').toLowerCase().trim()
          .includes((locationCity || '').toLowerCase().trim()) &&
        (locations.locationPostalCode || '').toLowerCase().trim()
          .includes((locationPostalCode || '').toLowerCase().trim())
    );
    setFilteredList(newLocation);
    setTotalResults(newLocation.length);
    setPage(1);
    setPageList(newLocation.slice(0, pageLength));
  }, [locationName, locationStreetAddress1, locationCity, locationPostalCode, locationList]);

  useEffect(() => {
    setIsLoading(true);
    Country.getAll().then((res) => {
      setCountryList(res);
      setIsLoading(false);
    }).catch((error) => {
      handlePageError(error.message);
    });
    CountrySubdivision.getAll().then((res) => {
      setCountrySubdivisionList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    OperationStatus.getAll().then((res) => {
      setOperationStatusList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    PrimaryUseType.getAll().then((res) => {
      setUseTypeList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    setCountry({ id: null, name: '' });

    Site.getAll().then((res) => {
      setSiteList(res);
      setIsLoading(false);
    }).catch((error) => {
      handlePageError(error.message);
    });
  }, []);

  useEffect(() => {
    if (country.id) {
      CountrySubdivision.getByCountryId(country.id).then((res) => {
        setCountrySubdivisionDropdown(res.data);
      }).catch((error) => {
        handlePageError(error.message);
      });
      City.getCities({CountryId: country.id, CountrySubdivisionId: null}).then((res) => {
        setLocationCityDropdown(res);
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
  }, [country]);

  useEffect(() => {
    if (country.id && countrySubdivision.id) {
      City.getCities({CountryId: country.id, CountrySubdivisionId: countrySubdivision.id}).then((res) => {
        setLocationCityDropdown(res);
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
  }, [country, countrySubdivision]);

  const changePageLength = (value) => {
    setPageLength(value);
    setPageList(filteredList.slice(0, value));
  };
  const handlePageChange = (direction) => {
    switch (direction) {
      case 0:
        setPageList(filteredList.slice(0, pageLength));
        setPage(1);
        break;
      case 1:
        if (page > 1) {
          setPageList(filteredList.slice(pageLength * (page - 2), pageLength * (page - 1)));
          setPage(page - 1);
        }
        break;
      case 2:
        if (page < Math.ceil(filteredList.length / pageLength)) {
          setPageList(filteredList.slice(pageLength * page, pageLength * (page + 1)));
          setPage(page + 1);
        }
        break;
      case 3:
        if (filteredList.length % pageLength === 0) {
          setPageList(filteredList.slice(filteredList.length - pageLength, filteredList.length));
        } else {
          setPageList(
            filteredList.slice(
              filteredList.length - (filteredList.length % pageLength),
              filteredList.length
            )
          );
        }
        setPage(Math.ceil(filteredList.length / pageLength));
        break;
      default:
        break;
    }
  };

  const handleCountryChange = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      let countryId = null;
      const countryMatch = countryList.find(
        (countryOption) => countryOption.countryName === country.name
      );
      if (countryMatch) {
        countryId = countryMatch.countryId;
      }
      setCountry({ id: countryId, name: `${event.target.value}` });
      setCountrySubdivision({ id: null, name: '' });
      setLocationCity('');
    } else {
      setCountry({ id: null, name: `${event.target.value}` });
      setCountrySubdivisionDropdown([]);
      setLocationCityDropdown([]);
    }
  };
  const handleCountryClick = (e, value) => {
    let countryId = null;
    let countryMatch = countryList.find((country) =>
      country.countryName === value
    );
    if (countryMatch) {
      countryId = countryMatch.countryId;
    }
    setCountry({ id: countryId, name: `${value}` });
    setCountrySubdivision({ id: null, name: '' });
    setLocationCity('');
  };

  const handleCountrySubdivisionChange = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      let countrySubdivisionId = null;
      const countrySubdivisionMatch = countrySubdivisionDropdown.find((countrySub) =>
        countrySub.countrY_SUBDIVISION_NAME === countrySubdivision.name
      );
      if (countrySubdivisionMatch) {
        countrySubdivisionId = countrySubdivisionMatch.countrY_SUBDIVISION_ID;
      }
      setCountrySubdivision({ id: countrySubdivisionId, name: `${event.target.value}` });
    } else {
      setCountrySubdivision({ id: null, name: `${event.target.value}` });
    }
  };
  const handleCountrySubdivisionClick = (e, value) => {
    let countrySubdivisionId = null;
    let countrySubdivisionMatch = countrySubdivisionList.find((countrySubdivision) =>
      countrySubdivision.countrY_SUBDIVISION_NAME === value
    );
    if (countrySubdivisionMatch) {
      countrySubdivisionId = countrySubdivisionMatch.countrY_SUBDIVISION_ID;
    }
    setCountrySubdivision({ id: countrySubdivisionId, name: `${value}` });
    setLocationCity('');
  };

  const handleLocationCityChange = (event) => {
    if (event.key === 'Enter' ) {
      event.preventDefault();
      setLocationCity(`${event.target.value}`);
    } else {
      setLocationCity(`${event.target.value}`);
    }
  }

  const searchByFilter = (event) => {
    setIsLoading(true);
    event.preventDefault();
    let filter = new SearchModel();
    if ((locationName || '').toLowerCase().trim()) {
      filter.locationName = (locationName || '').toLowerCase().trim();
    }
    if ((locationStreetAddress1 || '').toLowerCase().trim()) {
      filter.locationStreetAddress1 = (locationStreetAddress1 || '').toLowerCase().trim();
    }
    if ((locationPostalCode || '').toLowerCase().trim()) {
      filter.locationPostalCode = (locationPostalCode || '').toLowerCase().trim();
    }
    if ((locationCity || '').toLowerCase().trim()) {
      filter.locationCity = (locationCity || '').toLowerCase().trim();
    }
    if (country.id) {
      filter.countryId = parseInt(country.id);
      if (countrySubdivision.id) {
        filter.countrySubdivisionId = parseInt(countrySubdivision.id);
      }
    }
    if (siteId) {
      filter.siteId = parseInt(siteId);
    }
    if (sourceSystemReferenceId) {
      filter.sourceSystemReferenceId = sourceSystemReferenceId;
    }
    LocationService.getByFilter(filter).then((res) => {
      if (res.status === 200) {
        setLocationList(res.data);
        setFilteredList(res.data);
        setTotalResults(res.data.length);
      }
      setIsLoading(false);
    }).catch((error) => {
      handlePageError(error.message);
    });
  };

  const handleSiteChange = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      let siteId = 0;
      const siteMatch = siteList.find((siteOption) => siteOption.siteName === siteName);
      if (siteMatch) {
        setSiteId(siteMatch.siteId);
      }
      setSiteName(`${event.target.value}`);
    } else {
      setSiteName(`${event.target.value}`);
      setSiteId(0);
    }
  };

  const handleSiteClick = (event, value) => {
    const siteMatch = siteList.find((siteOption) => siteOption.siteName === value);
    if (siteMatch) {
      setSiteId(siteMatch.siteId);
    }
    setSiteName(value);
  };

  const renderLocationTable = (filteredList) => {
    return (
      <TableBodyRow className='table-row'>
        <TableBodyCell> {filteredList.locationName} </TableBodyCell>
        <TableBodyCell> {filteredList.locationStreetAddress1} </TableBodyCell>
        <TableBodyCell> {filteredList.locationCity} </TableBodyCell>
        <TableBodyCell>
          {' '}
          {countrySubdivisionList
            .filter((subDivision) =>
              subDivision.countrY_SUBDIVISION_ID === filteredList.countrySubdivisionId
            )
            .map((subDivision) => (
              subDivision.countrY_SUBDIVISION_NAME
            ))}{' '}
        </TableBodyCell>
        <TableBodyCell>
          {' '}
          {countryList
            .filter((country) => country.countryId === filteredList.site?.countryId)
            .map((country) => (
              country.countryName
            ))}{' '}
        </TableBodyCell>
        <TableBodyCell>
          {' '}
          {useTypeList
            .filter((useType) => useType.primaryUseTypeId === filteredList.primaryUseTypeId)
            .map((useType) => (
              useType.primaryUseTypeName
            ))}{' '}
        </TableBodyCell>
        <TableBodyCell>
          {' '}
          {operationStatusList
            .filter((status) => status.operationStatusId === filteredList.operationStatusId)
            .map((status) => (
              status.operationStatusName
            ))}{' '}
        </TableBodyCell>
        <TableBodyCell>
          <a href={'/viewlocation/' + filteredList.locationId}>
            <Button variant='tertiary' style={{ paddingBottom: '20px' }}>
              <EditIcon />
            </Button>
          </a>
        </TableBodyCell>
      </TableBodyRow>
    );
  };

  const handlePageError = (message) => {
    switch (true) {
      case (message.includes('Network')):
        setErrorCode('Network');
        break;
      case (message.includes('400')):
        setErrorCode('Bad Request');
        break;
      case (message.includes('403')):
        setErrorCode('Forbidden');
        break;
      case (message.includes('404')):
        setErrorCode('Not Found');
        break;
      case (message.includes('500') || message.includes('Internal Server')):
        setErrorCode('Internal Server');
        break;
      case (message.includes('map')):
        setErrorCode('Mapping');
        break;
      default:
        break;
    }
    setPageLoaded(false);
    setIsLoading(false);
  }

  return (
    <div>
      {pageLoaded && <div className='search-location-page'>
        {isLoading && <LoaderIcon />}
        <Section
          title={
            <div className='location-search-row'>
              <SearchIcon size='small' style={{ margin: '10px 0px 0px 5px' }} />
              <p style={{ margin: '0px 20px 0px 10px' }}>Search Location</p>
            </div>
          }
          underline='main'
        />
        <div>
          <Fieldset
            style={{
              padding: '0px',
              marginBottom: '0px',
              borderBottom: '1px solid #e5e5e5',
            }}
          >
            <Field style={{ margin: '0px' }}>
              <FieldLabel></FieldLabel>
              <FieldBody>
                <Search
                  style={{ padding: '0px 40px 0px 40px', width: '100%' }}
                  onSubmit={(e) => searchByFilter(e)}
                  inputProps={{
                    value: locationName,
                    onChange: (e) => setLocationName(e.target.value),
                    placeholder: 'Search Location Name',
                  }}
                />

                <Grid varient='3-up' style={{ padding: '0px 40px 0px 40px' }}>
                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel>Country</FieldLabel>
                      <FieldBody>
                        <Typeahead
                          onChange={(e, value) => {
                            handleCountryClick(e, value);
                          }}
                          inputProps={{
                            className: 'search-bar',
                            onChange: (e) => handleCountryChange(e),
                            onKeyPress: (e) => handleCountryChange(e),
                            value: country.name,
                          }}
                        >
                          {countryList
                            .filter((countries) =>
                              countries.countryName
                                ? countries.countryName.toLowerCase()
                                  .slice(0, country.name.toLowerCase().trim().length)
                                === country.name.toLowerCase().trim()
                                : ''
                            )
                            .map((country) => (
                              <TypeaheadItem
                                id={country.countryId}
                                key={country.countryId}
                                value={country.countryName}
                              >
                                <TypeaheadItemSuggestion>
                                  <span>{`${country.countryName} `}</span>
                                </TypeaheadItemSuggestion>
                              </TypeaheadItem>
                            ))}
                        </Typeahead>
                      </FieldBody>
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel>State/Province</FieldLabel>
                      <FieldBody className='countrySubdivision'>
                        <Typeahead
                          onChange={(e, value) => {
                            handleCountrySubdivisionClick(e, value);
                          }}
                          onFocus={(e) => setIsFocused(true)}
                          onBlur={(e) => setIsFocused(false)}
                          inputProps={{
                            className: 'search-bar',
                            onChange: (e) => handleCountrySubdivisionChange(e),
                            onKeyPress: (e) => handleCountrySubdivisionChange(e),
                            value: countrySubdivision.name,
                          }}
                          fieldProps={{
                            note: !country.id && isFocused ? 'Please select a Country' : ''
                          }}
                        >
                          {countrySubdivisionDropdown
                            .filter((countrySubdivisions) =>
                              countrySubdivisions.countrY_SUBDIVISION_NAME
                                ? countrySubdivisions.countrY_SUBDIVISION_NAME.toLowerCase()
                                  .slice(0, countrySubdivision.name.toLowerCase().trim().length)
                                === countrySubdivision.name.toLowerCase().trim()
                                : ''
                            )
                            .map((state) => (
                              <TypeaheadItem
                                id={state.countrY_SUBDIVISION_ID}
                                key={state.countrY_SUBDIVISION_ID}
                                value={state.countrY_SUBDIVISION_NAME}
                              >
                                <TypeaheadItemSuggestion>
                                  <span>{`${state.countrY_SUBDIVISION_NAME} `}</span>
                                </TypeaheadItemSuggestion>
                              </TypeaheadItem>
                            ))}
                        </Typeahead>
                      </FieldBody>
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel>City</FieldLabel>
                      <FieldBody className='locationCity'>
                        <Typeahead
                          onChange={(e, value) =>
                            setLocationCity(`${value}`)
                          }
                          onFocus={(e) => setIsFocused(true)}
                          onBlur={(e) => setIsFocused(false)}
                          inputProps={{
                            className: 'search-bar',
                            onChange: (e) => handleLocationCityChange(e),
                            onKeyPress: (e) => handleLocationCityChange(e),
                            value: locationCity,
                          }}
                          fieldProps={{
                            note: !country.id && isFocused ? 'Please select a Country' : ''
                          }}
                        >
                          {locationCityDropdown
                            .filter((item) =>
                              item.locationCity
                                ? item.locationCity.toLowerCase()
                                  .slice(0, locationCity.toLowerCase().trim().length)
                                === locationCity.toLowerCase().trim()
                                : ''
                            )
                            .map((item) => (
                              <TypeaheadItem
                                value={item.locationCity}
                              >
                                <TypeaheadItemSuggestion>
                                  <span>{`${item.locationCity} `}</span>
                                </TypeaheadItemSuggestion>
                              </TypeaheadItem>
                            ))}
                        </Typeahead>
                      </FieldBody>
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel> Address </FieldLabel>
                      <TextInput
                        className='location-search-bar'
                        onSubmit={(e) => e.preventDefault()}
                        inputProps={{
                          value: locationStreetAddress1,
                          onChange: (e) => setAddress(e.target.value),
                        }}
                      />
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel> Postal Code </FieldLabel>
                      <TextInput
                        className='location-search-bar'
                        onSubmit={(e) => e.preventDefault()}
                        inputProps={{
                          value: locationPostalCode,
                          onChange: (e) => setLocationPostalCode(e.target.value),
                        }}
                      />
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel>Site Name</FieldLabel>
                      <FieldBody>
                        <Typeahead
                          onSubmit={(e) => e.preventDefault()}
                          onChange={(e, value) => handleSiteClick(e, value)}
                          inputProps={{
                            className: 'search-bar',
                            onChange: (e) => handleSiteChange(e),
                            onKeyPress: (e) => handleSiteChange(e),
                            value: siteName,
                          }}
                        >
                          {siteList
                            .filter((site) =>
                              site.siteName.toLowerCase()
                                .slice(0, siteName.toLowerCase().trim().length)
                              === siteName.toLowerCase().trim()
                            )
                            .map((site) => (
                              <TypeaheadItem id={site.siteId} value={site.siteName}>
                                <TypeaheadItemSuggestion>
                                  <span>{`${site.siteName}`}</span>
                                </TypeaheadItemSuggestion>
                              </TypeaheadItem>
                            ))}
                        </Typeahead>
                      </FieldBody>
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item'>
                    <Field>
                      <FieldLabel> Source System Reference ID</FieldLabel>
                      <TextInput
                        className='location-search-bar'
                        onSubmit={(e) => e.preventDefault()}
                        inputProps={{
                          value: sourceSystemReferenceId,
                          onChange: (e) => setSourceSystemReferenceId(e.target.value),
                        }}
                      />
                    </Field>
                  </GridItem>

                  <GridItem className='location-grid-item' style={{ paddingTop: '33px' }}>
                    <Button
                      className='search-button'
                      variant='primary'
                      onClick={(e) => searchByFilter(e)}
                    >
                      Search
                    </Button>
                  </GridItem>
                </Grid>
              </FieldBody>
            </Field>
          </Fieldset>

          <Fieldset
            style={{
              backgroundColor: '#F5F5F5',
              borderBottom: '1px solid #e5e5e5',
            }}
          >
            <Table
              style={{ padding: '15px 40px 0px 40px', color: '#F5F5F5' }}
              footer={
                <Toolbar style={{ padding: '5px' }}>
                  <ToolbarItem left>{totalResults} results</ToolbarItem>
                  <ToolbarItem right>
                    <div className='paginator-row'>
                      <p style={{ paddingTop: '10px', paddingRight: '0px' }}>
                        Items per page:
                    </p>
                      <Select
                        value={pageLength}
                        onChange={(e) => changePageLength(e.target.value)}
                        style={{ paddingRight: '10px', paddingLeft: '0px' }}
                        selectProps={{
                          className: 'paginator-select',
                        }}
                      >
                        <option value='5'>5</option>
                        <option value='10'>10</option>
                        <option value='20'>20</option>
                      </Select>
                      <Button
                        onClick={(e) => handlePageChange(0)}
                        variant='tertiary'
                        style={{ padding: '0px', transform: 'rotateY(180deg)' }}
                      >
                        <ChevronHardStopIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(1)}
                        variant='tertiary'
                        style={{ padding: '0px 5px 0px 10px' }}
                      >
                        <ChevronLeftIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(2)}
                        variant='tertiary'
                        style={{ padding: '0px 10px 0px 5px' }}
                      >
                        <ChevronRightIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(3)}
                        variant='tertiary'
                        style={{ padding: '0px' }}
                      >
                        <ChevronHardStopIcon size='small' />
                      </Button>
                    </div>
                  </ToolbarItem>
                </Toolbar>
              }
            >
              <TableHead>
                <TableHeadRow>
                  <TableHeadCell> Location Name </TableHeadCell>
                  <TableHeadCell> Address </TableHeadCell>
                  <TableHeadCell> City </TableHeadCell>
                  <TableHeadCell> State/Province </TableHeadCell>
                  <TableHeadCell> Country </TableHeadCell>
                  <TableHeadCell> Primary Use Type </TableHeadCell>
                  <TableHeadCell> Operation Status </TableHeadCell>
                  <TableHeadCell style={{ width: '5px' }}> </TableHeadCell>
                </TableHeadRow>
              </TableHead>
              <TableBody>{pageList.map(renderLocationTable)}</TableBody>
            </Table>
          </Fieldset>
        </div>
      </div>}

      {!pageLoaded && <div>
        <h1 style={{ textAlign: 'center', fontSize: '2rem' }}>
          {errorCode} Error Occurred
        </h1>
      </div>}
    </div>
  );
}
export default SearchLocation;
